import Vue from 'vue'
import Router from 'vue-router'
import Policeman from '@/utils/Policeman/policeman'

// Containers
import Full from '@/containers/Full'
import Login from '@/components/Login'

// Dashboard views
import Dashboard from '@/components/Dashboard'

// User views
import UserIndex from '@/components/User/Index'
import UserForm from '@/components/User/Form'

// Project views
import ProjectIndex from '@/components/Project/Index'
import ProjectForm from '@/components/Project/Form'
import ProjectStructuresManagement from '@/components/Project/StructuresManagement'

// Structure views
import StructureIndex from '@/components/Structure/Index'
import StructureForm from '@/components/Structure/Form'
import StructureShow from '@/components/Structure/Show'

// Checklist views
import ChecklistIndex from '@/components/Checklist/Index'
import ChecklistShow from '@/components/Checklist/Show'
import ChecklistNew from '@/components/Checklist/New'
import ChecklistEdit from '@/components/Checklist/Edit'

Vue.use(Router)

const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            roles: Policeman.getRoles('dashboard', 'index'),
            entity: 'dashboard'
          }
        },
        { // user routes
          path: 'users',
          redirect: 'users/list',
          name: 'Users',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            roles: Policeman.getRoles('user', 'index'),
            entity: 'user'
          },
          children: [
            {
              path: 'list',
              name: 'All users',
              component: UserIndex,
              meta: {
                roles: Policeman.getRoles('user', 'index'),
                entity: 'user'
              }
            },
            {
              path: 'form',
              name: 'New user',
              component: UserForm,
              meta: {
                roles: Policeman.getRoles('user', 'new'),
                entity: 'user'
              }
            },
            {
              path: 'form/:id',
              name: 'Edit user',
              component: UserForm,
              meta: {
                roles: Policeman.getRoles('user', 'edit'),
                entity: 'user'
              }
            }
          ]
        },
        { // project routes
          path: 'projects',
          redirect: 'projects/list',
          name: 'Projects',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            roles: Policeman.getRoles('project', 'index'),
            entity: 'project'
          },
          children: [
            {
              path: 'list',
              name: 'All projects',
              component: ProjectIndex,
              meta: {
                roles: Policeman.getRoles('project', 'index'),
                entity: 'project'
              }
            },
            {
              path: 'form',
              name: 'New project',
              component: ProjectForm,
              meta: {
                roles: Policeman.getRoles('project', 'new'),
                entity: 'project'
              }
            },
            {
              path: 'form/:id',
              name: 'Edit project',
              component: ProjectForm,
              meta: {
                roles: Policeman.getRoles('project', 'edit'),
                entity: 'project'
              }
            },
            {
              path: ':id/objects_management',
              name: 'Project objects management',
              component: ProjectStructuresManagement,
              meta: {
                roles: Policeman.getRoles('project', 'edit'),
                entity: 'project'
              }
            }
          ]
        },
        { // structure routes (the user sees Objects)
          path: 'structures',
          redirect: 'structures/list',
          name: 'Objects',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            roles: Policeman.getRoles('structure', 'index'),
            entity: 'structure'
          },
          children: [
            {
              path: 'list',
              name: 'All objects',
              component: StructureIndex,
              meta: {
                roles: Policeman.getRoles('structure', 'index'),
                entity: 'structure'
              }
            },
            {
              path: 'form',
              name: 'New object',
              component: StructureForm,
              meta: {
                roles: Policeman.getRoles('structure', 'new'),
                entity: 'structure'
              }
            },
            {
              path: 'form/:id',
              name: 'Edit object',
              component: StructureForm,
              meta: {
                roles: Policeman.getRoles('structure', 'edit'),
                entity: 'structure'
              }
            },
            {
              path: 'show/:id',
              name: 'Show object',
              component: StructureShow,
              meta: {
                roles: Policeman.getRoles('structure', 'show'),
                entity: 'structure'
              }
            }
          ]
        },
        { // checklist routes
          path: 'checklists',
          redirect: 'checklists/list',
          name: 'Inspections',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            roles: Policeman.getRoles('checklist', 'index'),
            entity: 'checklist'
          },
          children: [
            {
              path: 'list',
              name: 'All inspections',
              component: ChecklistIndex,
              meta: {
                roles: Policeman.getRoles('checklist', 'index'),
                entity: 'checklist'
              }
            },
            {
              path: 'form',
              name: 'New inspection',
              component: ChecklistNew,
              meta: {
                roles: Policeman.getRoles('checklist', 'new'),
                entity: 'checklist'
              }
            },
            {
              path: 'form/:id',
              name: 'Edit inspection',
              component: ChecklistEdit,
              meta: {
                roles: Policeman.getRoles('checklist', 'edit'),
                entity: 'checklist'
              }
            },
            {
              path: 'report/:id',
              name: 'Show inspection',
              component: ChecklistShow,
              meta: {
                roles: Policeman.getRoles('checklist', 'show'),
                entity: 'checklist'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth === false) { return next() }
  if (Policeman.authorize(to.meta.roles)) {
    return next()
  } else {
    return next({ name: 'Login' })
  }
})

export { router }



// WEBPACK FOOTER //
// ./src/router/index.js